export const NAME = 'semaphore';

export const contactAgeIds = {
	semaphorePO: 15,
	oneToTwoYears: 20,
	threeToFourYears: 23,
	fiveToSixYears: 26,
	sevenAndLaterYears: 29,
};

export const contactAgeIdLocalizations = {
	20: 'semaphore:contact1To2year',
	23: 'semaphore:contact3To4year',
	26: 'semaphore:contact5To6year',
	29: 'semaphore:contact7AndLater',
	15: 'semaphore:semaphorePO',
};

export const unspecifiedFeedbackOption = {
	id: '-1',
	company: 'CP',
	language: 3,
	shortDescription: 'Nezadáno',
	description: 'Nezadáno',
};

export const productDomainsSelectAllOption = {
	id: 'selectAll',
	description: 'common:selectAll',
};

export const halfDoughnutLabels = ['Green', 'Orange', 'Red', 'Grey'];

export const halfDoughnutNameLabelMap = {
	Green: 'Kontakt před max. 2 lety',
	Orange: 'Kontakt před více než 2, ale max. 4 lety',
	Red: 'Kontakt před více než 4, ale max. 6 lety',
	Grey: 'Kontakt před více než 6 lety',
};

export const transitionRowWithDefaultValues = [0, 0, 0];

export const REQUEST_SIZE_LIMIT = 500;

export const dialogs = {
	TOO_MANY_RESULTS: `${NAME}/TOO_MANY_RESULTS`,
};

export const formDataFieldsMap = {
	surname: 'Příjmení',
	firstName: 'Jméno',
	birthNumber: 'Rodné číslo',
	taxNumber: 'IČO',
	productArea: 'Produktová oblast',
	notInsuredProductArea: 'Nemá pojištěno',
	municipality: 'Obec',
	zipCode: 'PSČ',
	feedback: 'Zpětná vazba',
	birthYearFrom: 'Rok narození od',
	birthYearTo: 'Rok narození do',
	semaphore: 'Semafor',
	impendingState: 'Hrozící stav',
};
